import { Injectable } from "@angular/core";
import { LeftMenuService } from "../services";

@Injectable()
export class LeftMenuFacade {
  constructor(private readonly leftMenuService: LeftMenuService) {}

  get isOpen$() {
    return this.leftMenuService.isOpen$;
  }

  open() {
    this.leftMenuService.open();
  }
}
